
import Swal from "sweetalert2";
import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import Navbar from "../../../components/Navbar.js";
import Select from "react-select";
import Switch from "react-switch";
import LOGO from "../../../assets/images/logo.png";
import SignatureCanvas from 'react-signature-canvas';
import CreatableSelect from 'react-select/creatable';
import {
    locale,
    tokens,
    select_style,
    required,
    // alert
    success,
    success_url,
    alert,
    alert_url,
    // function
    logout,
    number_zero,
    format_date,
    toFixed,
    total,
    validate,
    random_charactor,
    float,
    // api
    GET,
    POST,
    PUT,
    DELETE,
    error_message,
    // storage
    removeStorage,
    getStorage,

    validate_email,
    validate_th,
    validate_en,
    validate_en_number,

    LinktoBase64,
    // component
    DatePicker,
} from "../../../components/CustomComponent.js";

import "../../../components/global.js";
import "../../../assets/css/bootstrap.css";
import "../../../assets/css/index.css";
import BarcodeComponent from '../../../components/BarcodeComponent';

export default class Dashboard extends Component {
    constructor(props) {
        super(props)
        this.state = {
            modal_create: false,
            modal_delete: false,
            modal_update: false,


            loading: false,
            data_supplier: [],
            data_product: [],
            data_code_product: [],
            data_warehouse: [],
            stock_item_list: [],

            g_rec_main_id: "",
            bill_receipt_code: "",
            company_id: "",
            tax_number: "",
            address: "",
            barcode_config: {
                paper_size: '100x100',
                show_code: false,
                show_name: false,
                show_price: false,
                show_lot: false,
            },

            product_code: "",
            product_name: "",
            quantity: "",
            price_by_item: "",
            serial_numbers: [],

            discount: "",
            remark: "",
            is_vat: false,

            decision_status: "0",
            confirm_approve: false,

            warehouse_id: ""
        }
    }
    async componentDidMount() {
        this.setState({ loading: true });
        await this.GetSupplier();
        await this.getProductAll();
        await this.GetWarehouse();
        await this.GetBarcodeConfig();
        if (this.props.location.query.id) {
            this.GetById(this.props.location.query.id)
        }
        this.setState({ loading: false });
        this.handlePrint = (width,height,index) => {
            console.log('Printing')  
            const printContents = document.getElementById("section-to-print-"+index).innerHTML;
            let text_size = '.justify-content-center {  margin: 10px; padding: 10px; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); h5,p,div { margin: 0; }'

            if(height !== '100'){
                text_size = 'h5,p,div { margin: 0; padding: 0; font-size: 7px; }'
            }

            const printWindow = window.open('', '', 'height='+1000+',width='+1000);
            printWindow.document.write('<html><head>');
            printWindow.document.write('<style media="print">@page {size: '+(width)+'mm '+(height)+'mm; margin: 0; .text-barcode {margin: 0;} }  '+text_size+'} </style>');
            printWindow.document.write('</head><body>');
            printWindow.document.write(printContents);
            printWindow.document.write('</body></html>');
            printWindow.document.close();
            printWindow.focus();
            printWindow.print();
            printWindow.close();
        }
    }

    GetById = async (id) => {
        let body = {
            page: "",
            data_search: "",
            g_rec_main_id: id
        }
        let result = await GET(tokens, "v1/TH/goods-receipt/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log("GetById:", result);
            this.setState({
                g_rec_main_id: id,
                bill_receipt_code: result.data.bill_receipt_code,
                company_id: result.data.relation_company_supplier ? this.state.data_supplier.filter(item => item.value === result.data.relation_company_supplier.company_id)[0] : "",
                tax_number: result.data.tax_number ? result.data.tax_number : result.data.relation_company_supplier.tax_number,
                address: result.data.relation_company_supplier ? this.state.data_supplier.filter(item => item.value === result.data.relation_company_supplier.company_id)[0].address : "",

                discount: result.data.discount,
                is_vat: result.data.vat !== 0 ? true : false,
                remark: result.data.remark,

                decision_status: result.data.decision_status.toString(),
                warehouse_id: result.data.relation_warehouse ? { value: result.data.relation_warehouse.warehouse_id, label: result.data.relation_warehouse.warehouse_name } : "",
                stock_item_list: result.data.goods_receipt_list.map(item => {
                    console.log("goods_receipt_list :",item)
                    return {
                        product_code: item.relation_product_main.product_code ? this.state.data_code_product.filter(e => e.value === item.relation_product_main.product_code)[0] : "",
                        product_name: item.relation_product_main.product_name ? this.state.data_product.filter(e => e.value === item.relation_product_main.product_name)[0] : "",
                        quantity: item.quantity,
                        price_by_item: item.price_by_item,
                        total_price_by_item: item.total_price_by_item,
                        serial_numbers: item.serial_numbers || []
                    }
                })
            })
            // this.setState({ data: result });
        }
    }
    GetSupplier = async () => {
        let body = {
            page: 0,
            data_search: "",
            company_type: 2,
            company_id: ""
        }
        let result = await GET(tokens, "v1/TH/company-info/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result);
            this.setState({ data_supplier: result.data.map(e => { return { value: e.company_id, label: e.company_name, tax_number: e.tax_number, address: e.address } }) });
        }
    }
    getProductAll = async () => {
        let body = {
            page: 0,
            data_search: "",
            product_code: ""
        }
        let result = await GET(tokens, "v1/TH/product-manage/product/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result);
            this.setState({ 
                data_product: result.data.map(e => { return { value: e.product_name, label: e.product_name, ...e } }),
                data_code_product: result.data.map(e => { return { value: e.product_code, label: e.product_code, ...e } })
            });
        }
    }

    GetBarcodeConfig = async () => {
        this.setState({ loading: true });
        let body = {
            page: this.state.page,
            data_search: this.state.data_search,
            product_id: ""
        }

        let result = await GET(tokens, "v1/TH/goods-receipt/barcode/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            this.setState({ barcode_config: result.data });
        }
        this.setState({ loading: false });
    }

    handleCreate = (inputValue) => {
        window.location.href = '/master/spare-parts-repair/create?type=อะไหล่&name=' + inputValue;
    };

    GetWarehouse = async () => {
        this.setState({ loading: true });
        let body = {
            page: 0,
            data_search: ""
        }
        let result = await GET(tokens, "v1/TH/warehouse-info/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result);
            this.setState({
                data_warehouse: result.data.map(e => {
                    return { value: e.warehouse_id, label: e.warehouse_name }
                })
            });
        }
        this.setState({ loading: false });
    }
    Create = async () => {
        this.setState({ loading: true });
        let data = {
            bill_receipt_code: "",
            ref_receipt_code: "",
            company_id: this.state.company_id ? this.state.company_id.value : "",
            discount: Number(this.state.discount),
            address: this.state.address,
            office_number: "",
            tax_number: this.state.tax_number,
            remark: this.state.remark,
            total_price: Number(total(this.state.stock_item_list, "total_price_by_item")),
            vat: this.state.is_vat ? Number(toFixed((total(this.state.stock_item_list, "total_price_by_item") - Number(this.state.discount)) * 0.07)) : 0,
            total_price_final: Number(total(this.state.stock_item_list, "total_price_by_item") - Number(this.state.discount) + Number(this.state.is_vat ? Number(toFixed((total(this.state.stock_item_list, "total_price_by_item") - Number(this.state.discount)) * 0.07)) : 0)),
            decision_remark: "",
            decision_status: 0,
            receive_date: format_date(new Date(), "dd/mm/yyyy", "en"),
            credit_day: 0,
            due_date: format_date(new Date(), "dd/mm/yyyy", "en"),
            warehouse_id: this.state.warehouse_id ? this.state.warehouse_id.value : "",
            stock_item_list: this.state.stock_item_list.map(item => {
                return {
                    product_code: item.product_code ? item.product_code.value : "",
                    price_by_item: Number(item.price_by_item),
                    quantity: Number(item.quantity),
                    total_price_by_item: Number(item.total_price_by_item),
                    serial_numbers: item.serial_numbers
                }
            }),
        }
        let result = await POST(tokens, "v1/TH/goods-receipt/create/" + getStorage("branch").branch_id, data);
        if (result && result.status) {
            success_url("/order/list-receipt");
        }
        this.setState({ loading: false });
    }
    Update = async () => {

        this.setState({ loading: true });
        let data = {
            g_rec_main_id: this.state.g_rec_main_id,
            bill_receipt_code: "",
            ref_receipt_code: "",
            company_id: this.state.company_id ? this.state.company_id.value : "",
            discount: Number(this.state.discount),
            address: this.state.address,
            office_number: "",
            tax_number: this.state.tax_number,
            remark: this.state.remark,
            total_price: Number(total(this.state.stock_item_list, "total_price_by_item")),
            vat: this.state.is_vat ? Number(((total(this.state.stock_item_list, "total_price_by_item") - Number(this.state.discount)) * 0.07)) : 0,
            total_price_final: Number(total(this.state.stock_item_list, "total_price_by_item") - Number(this.state.discount) + Number(this.state.is_vat ? Number(((total(this.state.stock_item_list, "total_price_by_item") - Number(this.state.discount)) * 0.07)) : 0)),
            decision_remark: "",
            decision_status: Number(this.state.decision_status),
            receive_date: format_date(new Date(), "dd/mm/yyyy", "en"),
            credit_day: 0,
            due_date: format_date(new Date(), "dd/mm/yyyy", "en"),
            warehouse_id: this.state.warehouse_id ? this.state.warehouse_id.value : "",
            stock_item_list: this.state.stock_item_list.map(item => {
                return {
                    product_code: item.product_code ? item.product_code.value : "",
                    product_name: item.product_name ? item.product_name.value : "",
                    price_by_item: Number(item.price_by_item),
                    quantity: Number(item.quantity),
                    total_price_by_item: Number(item.total_price_by_item),
                    serial_numbers: item.serial_numbers,
                }
            }),
        }
        let result = await PUT(tokens, "v1/TH/goods-receipt/update", data);
        if (result && result.status) {
            success_url("/order/list-receipt");
        }
        this.setState({ loading: false });
    }

    render() {
        return (
            <div className="w-100 min-vh-100 fade-in">
                {this.state.loading && (<div className="spinner-container"> <div className="loading-spinner"></div> </div>)}
                <Navbar page1="หน้าหลัก" page2="แดชบอร์ด" />
                {/* BODY */}
                <div className="body bg-light min-vh-100">
                    <div className="p-3">
                        {/* หัวข้อ และ ปุ่มเพิ่ม */}
                        <div className="d-flex mx-0 align-items-center justify-content-between test mb-2 flex-wrap">
                            <h3 className="mb-2"><b>สร้างใบรับสินค้า  {this.state.bill_receipt_code} : </b><b className="text-orange">รออนุมัติ</b></h3>
                            <button className="btn btn-outline-orange mx-1" onClick={() => { window.location.href = "/order/list-order" }}>
                                <span className="icon me-2">{"\uf060"}</span>ย้อนกลับ
                            </button>
                        </div>
                        <div className="row">
                            <div className="col-12 mb-2">
                                <div className="w-100 card border-0 p-3 rounded-lg">
                                    <div className="row mb-2">
                                        <div className="col-12 col-md-6">
                                            <label className="mb-2">ชื่อบริษัท:</label>
                                            <Select
                                                className="form-control select-search"
                                                styles={select_style}
                                                options={this.state.data_supplier}
                                                onChange={(e) => {
                                                    this.setState({ company_id: e });
                                                    if (e) {
                                                        this.setState({ tax_number: e.tax_number, address: e.address })
                                                    } else {
                                                        this.setState({ tax_number: "", address: "" })
                                                    }
                                                }}
                                                value={this.state.company_id}
                                                isClearable
                                            ></Select>
                                        </div>
                                        <div className="col-12 col-md-6">
                                            <label className="mb-2">เลขที่ผู้เสียภาษี:</label>
                                            <input
                                                className="form-control mb-2"
                                                type="text"
                                                placeholder=""
                                                onChange={(e) => { this.setState({ tax_number: e.target.value }) }}
                                                value={this.state.tax_number}
                                                readOnly
                                            />
                                        </div>
                                        <div className="col-12 col-md-6">
                                            <label className="mb-2">ที่อยู่:</label>
                                            <textarea
                                                className="form-control mb-2"
                                                placeholder=""
                                                onChange={(e) => { this.setState({ address: e.target.value }) }}
                                                value={this.state.address}
                                                rows={5}
                                                readOnly
                                            />
                                        </div>
                                        <div className="col-12 col-md-6">
                                            <div className="w-100 mb-2">
                                                <label className="mb-2">คลังสินค้า:</label>
                                                <Select
                                                    className="form-control select-search"
                                                    styles={select_style}
                                                    options={this.state.data_warehouse}
                                                    onChange={(e) => {
                                                        this.setState({ warehouse_id: e });
                                                    }}
                                                    value={this.state.warehouse_id}
                                                    isClearable
                                                ></Select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="w-100 card border-0 p-0 rounded-lg" style={{ height: "100%" }}>
                                    <div>
                                        <table className="table table-borderless table-striped">
                                            <thead className="bg-primary">
                                                <tr>
                                                    <th className="text-center text-white wpx-70">ลำดับ</th>
                                                    <th className="text-left text-white">รหัสสินค้า</th>
                                                    <th className="text-left text-white">ชื่อสินค้า</th>
                                                    <th className="text-center text-white wpx-110">จำนวน</th>
                                                    <th className="text-end text-white wpx-110">ราคา/หน่วย</th>
                                                    <th className="text-end text-white wpx-110">ราคา</th>
                                                    <th className="text-center text-white wpx-70">จัดการ</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.stock_item_list.map((item, index) => {
                                                    return (
                                                        <><tr>
                                                            <td className="text-center">{index + 1}</td>
                                                            <td>
                                                                <Select
                                                                    className="form-control select-search"
                                                                    styles={select_style}
                                                                    options={this.state.data_code_product}
                                                                    onChange={(e) => {
                                                                        let stock_item_list = this.state.stock_item_list;
                                                                        const item = {...e}
                                                                        delete item['value']
                                                                        delete item['label']
                                                                        stock_item_list[index].product_code = { value: item.product_code, label: item.product_code, ...item };
                                                                        stock_item_list[index].product_name = { value: item.product_name, label: item.product_name, ...item };
                                                                        if (e) {
                                                                            stock_item_list[index].price = e.sell_price;
                                                                            stock_item_list[index].have_serial = e.have_serial;
                                                                        } else {
                                                                            stock_item_list[index].price = "";
                                                                            stock_item_list[index].have_serial = false;
                                                                        }
                                                                        stock_item_list[index].total_price = Number(stock_item_list[index].price) * Number(stock_item_list[index].quantity);
                                                                        this.setState({ stock_item_list: stock_item_list });
                                                                    }}
                                                                    value={item.product_code}
                                                                    isClearable
                                                                ></Select>                                                       
                                                            </td>
                                                            <td>
                                                                <Select
                                                                    className="form-control select-search"
                                                                    styles={select_style}
                                                                    options={this.state.data_product}
                                                                    onChange={(e) => {
                                                                        let stock_item_list = this.state.stock_item_list;
                                                                        const item = {...e}
                                                                        delete item['value']
                                                                        delete item['label']
                                                                        stock_item_list[index].product_code = { value: item.product_code, label: item.product_code, ...item };
                                                                        stock_item_list[index].product_name = { value: item.product_name, label: item.product_name, ...item };
                                                                        if (e) {
                                                                            stock_item_list[index].price = e.sell_price;
                                                                            stock_item_list[index].have_serial = e.have_serial;
                                                                        } else {
                                                                            stock_item_list[index].price = "";
                                                                            stock_item_list[index].have_serial = false;
                                                                        }
                                                                        stock_item_list[index].total_price = Number(stock_item_list[index].price) * Number(stock_item_list[index].quantity);
                                                                        this.setState({ stock_item_list: stock_item_list });
                                                                    }}
                                                                    value={item.product_name}
                                                                    isClearable
                                                                ></Select>                                                       
                                                            </td>
                                                            <td>
                                                                <input
                                                                    className="form-control text-end"
                                                                    type="text"
                                                                    placeholder=""
                                                                    onChange={(e) => {
                                                                        if (!float(e.target.value)) {
                                                                            return
                                                                        }
                                                                        let stock_item_list = this.state.stock_item_list;
                                                                        stock_item_list[index].quantity = Number(e.target.value);
                                                                        stock_item_list[index].total_price_by_item = Number(stock_item_list[index].price_by_item) * Number(stock_item_list[index].quantity);

                                                                        if( e.target.value > 0){
                                                                            const newSN = []
                                                                            const sn = stock_item_list[index].serial_numbers
                                                                            for (let index = 0; index < e.target.value; index++) {
                                                                                newSN.push(sn[index])
                                                                            }

                                                                            stock_item_list[index].serial_numbers = newSN
                                                                        }

                                                                        this.setState({ stock_item_list: stock_item_list });
                                                                    }}
                                                                    value={item.quantity}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    className="form-control text-end"
                                                                    type="text"
                                                                    placeholder=""
                                                                    onChange={(e) => {
                                                                        if (!float(e.target.value)) {
                                                                            return
                                                                        }
                                                                        let stock_item_list = this.state.stock_item_list;
                                                                        stock_item_list[index].price_by_item = e.target.value;
                                                                        stock_item_list[index].total_price_by_item = Number(stock_item_list[index].price_by_item) * Number(stock_item_list[index].quantity);
                                                                        this.setState({ stock_item_list: stock_item_list });
                                                                    }}
                                                                    value={item.price_by_item}
                                                                />
                                                            </td>
                                                            <td className="text-end">{toFixed(item.total_price_by_item)}</td>
                                                            <td>
                                                                {this.state.decision_status != 1 && (
                                                                    <div className="w-100 d-flex justify-content-center">
                                                                        <div className="pointer wpx-30 hpx-30 rounded bg-danger-light mx-1 d-flex justify-content-center align-items-center"
                                                                            onClick={() => {
                                                                                Swal.fire({
                                                                                    icon: "warning",
                                                                                    title: "แจ้งเตือน",
                                                                                    text: "ยืนยันการลบ \"" + item.product_code.label + "\" หรือไม่ \nหากลบแล้วจะไม่สามารถย้อนคืนข้อมูลที่ลบไปได้",
                                                                                    confirmButtonText: "ตกลง",
                                                                                    cancelButtonText: "ยกเลิก",
                                                                                    showCancelButton: true,
                                                                                }).then((result) => {
                                                                                    if (result.isConfirmed) {
                                                                                        let stock_item_list = this.state.stock_item_list;
                                                                                        stock_item_list.splice(index, 1);
                                                                                        this.setState({ stock_item_list: stock_item_list });
                                                                                    }
                                                                                });
                                                                            }}>
                                                                            <label className="pointer icon text-danger p-2">{"\uf2ed"}</label>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                {this.state.decision_status == 1 && (
                                                                    <div className="w-100 d-flex justify-content-center">
                                                                        <div className="pointer wpx-30 hpx-30 rounded bg-primary-light mx-1 d-flex justify-content-center align-items-center"
                                                                            onClick={() => this.handlePrint(
                                                                                this.state.barcode_config['paper_size'].split('x')[0],
                                                                                this.state.barcode_config['paper_size'].split('x')[1],
                                                                                index
                                                                            )} >
                                                                            <label className="pointer icon text-primary p-2">{"\uf02f"}</label>
                                                                        </div>
                                                                        <div style={{ display: 'none', '@media print': { display: 'block' } }} id={"section-to-print-"+index}>
                                                                            <div style={{ textAlign: 'center' }}>
                                                                                <BarcodeComponent 
                                                                                    ref={(refer) => (this.componentRef = refer)}
                                                                                    value={this.state.stock_item_list[index].product_code.value}
                                                                                    show_code={this.state.barcode_config['show_code']}
                                                                                    show_name={this.state.barcode_config['show_name']}
                                                                                    show_price={this.state.barcode_config['show_price']}
                                                                                    show_lot={this.state.barcode_config['show_lot']}
                                                                                    code={this.state.stock_item_list[index].product_code.value}
                                                                                    name={this.state.stock_item_list[index].product_name.value}
                                                                                    price={""}
                                                                                    lot={""}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </td>
                                                        </tr>
                                                        { this.state.stock_item_list[index].quantity > 0 && this.state.stock_item_list[index].product_code['have_serial'] && Array.apply(0, Array(this.state.stock_item_list[index].quantity)).map((item_sub, index_sub) => {
                                                            return (
                                                                <tr>
                                                                    <td className="text-center"></td>
                                                                    <td colSpan="3" className="ps-5">
                                                                        <input
                                                                            className="form-control"
                                                                            type="text"
                                                                            placeholder="Serial Number"
                                                                            onChange={(e) => {
                                                                                let stock_item_list = this.state.stock_item_list;
                                                                                stock_item_list[index].serial_numbers[index_sub] = e.target.value;
                                                                                this.setState({ stock_item_list: stock_item_list });
                                                                            }}
                                                                            value={item.serial_numbers[index_sub]}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            );
                                                        }) }
                                                        </>
                                                    )
                                                }
                                            )}
                                            {this.state.decision_status != 1 && (
                                                <tr>
                                                    <td className="text-center">-</td>
                                                    <td>
                                                        <CreatableSelect
                                                            className="form-control select-search"
                                                            styles={select_style}
                                                            options={this.state.data_code_product}
                                                            onChange={(e) => {
                                                                const item = {...e}
                                                                delete item['value']
                                                                delete item['label']
                                                                this.setState({ 
                                                                    product_code: { value: item.product_code, label: item.product_code, ...item },
                                                                    product_name: { value: item.product_name, label: item.product_name, ...item }
                                                                });
                                                                if (e) {
                                                                    console.log('ss : ',e)
                                                                    this.setState({ 
                                                                        price: e.sell_price,
                                                                        serial_numbers: []
                                                                    });
                                                                } else {
                                                                    this.setState({ price_by_item: "", serial_numbers: [] });
                                                                }
                                                            }}
                                                            onCreateOption={this.handleCreate}
                                                            value={this.state.product_code}
                                                            isClearable
                                                            placeholder="เลือกหรือสร้างสินค้า..."
                                                        />
                                                    </td>
                                                    <td>
                                                        <CreatableSelect
                                                            className="form-control select-search"
                                                            styles={select_style}
                                                            options={this.state.data_product}
                                                            onChange={(e) => {
                                                                const item = {...e}
                                                                delete item['value']
                                                                delete item['label']
                                                                this.setState({ 
                                                                    product_code: { value: item.product_code, label: item.product_code, ...item },
                                                                    product_name: { value: item.product_name, label: item.product_name, ...item }
                                                                });
                                                                if (e) {
                                                                    console.log('ss : ',e)
                                                                    this.setState({ 
                                                                        price: e.sell_price,
                                                                        serial_numbers: []
                                                                    });
                                                                } else {
                                                                    this.setState({ price_by_item: "", serial_numbers: [] });
                                                                }
                                                            }}
                                                            onCreateOption={this.handleCreate}
                                                            value={this.state.product_name}
                                                            isClearable
                                                            placeholder="เลือกหรือสร้างสินค้า..."
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            className="form-control text-end"
                                                            type="text"
                                                            placeholder=""
                                                            onChange={(e) => {
                                                                if (!float(e.target.value)) {
                                                                    return
                                                                }
                                                                const newSN = []
                                                                const sn = this.state.serial_numbers
                                                                for (let index = 0; index < e.target.value; index++) {
                                                                    newSN.push(sn[index])
                                                                }
                                                                this.setState({ 
                                                                    quantity: Number(e.target.value),
                                                                    serial_numbers: sn
                                                                });
                                                            }}
                                                            value={this.state.quantity}
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            className="form-control text-end"
                                                            type="text"
                                                            placeholder=""
                                                            onChange={(e) => {
                                                                if (!float(e.target.value)) {
                                                                    return
                                                                }
                                                                this.setState({ price_by_item: e.target.value });
                                                            }}
                                                            value={this.state.price_by_item}
                                                        />
                                                    </td>
                                                    <td className="text-end">
                                                        <div className="pt-2">
                                                            <label className="mb-2">{toFixed(this.state.quantity * this.state.price_by_item)}</label>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="w-100 d-flex justify-content-center">
                                                            <div className="wpx-30 hpx-30 rounded-circle bg-blue text-24 text-white d-flex justify-content-center align-items-center pointer"
                                                                onClick={() => {
                                                                    if (!this.state.product_code) {
                                                                        alert("warning", "แจ้งเตือน", "กรุณาเลือกสินค้า");
                                                                        return;
                                                                    } else if (!this.state.quantity) {
                                                                        alert("warning", "แจ้งเตือน", "กรุณากรอกจำนวน");
                                                                        return;
                                                                    } else if (!this.state.price_by_item) {
                                                                        alert("warning", "แจ้งเตือน", "กรุณากรอกราคาต่อหน่วย");
                                                                        return;
                                                                    }
                                                                    else if ( this.state.product_code['have_serial'] && ( this.state.serial_numbers.length < Number(this.state.quantity) || this.state.serial_numbers.length === 0 ) ) {
                                                                        alert("warning", "แจ้งเตือน", "กรุณากรอก Serial Number");
                                                                        return;
                                                                    }
                                                                    let stock_item_list = this.state.stock_item_list;
                                                                    stock_item_list.push({
                                                                        product_code: this.state.product_code,
                                                                        product_name: this.state.product_name,
                                                                        quantity: Number(this.state.quantity),
                                                                        price_by_item: Number(this.state.price_by_item),
                                                                        total_price_by_item: Number(this.state.quantity) * Number(this.state.price_by_item),
                                                                        serial_numbers: this.state.serial_numbers,
                                                                    })
                                                                    this.setState({
                                                                        stock_item_list: stock_item_list,
                                                                        product_code: null,
                                                                        product_name: null,
                                                                        quantity: "",
                                                                        price_by_item: "",
                                                                    })
                                                                }}>+</div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                                {this.state.quantity > 0 && this.state.product_code['have_serial'] && Array.apply(0, Array(this.state.quantity)).map((x, i) => {
                                                    return (
                                                        <tr>
                                                            <td className="text-center"></td>
                                                            <td colSpan="3" className="ps-5">
                                                                <input
                                                                    className="form-control"
                                                                    type="text"
                                                                    placeholder="Serial Number"
                                                                    onChange={(e) => {
                                                                        let serial_numbers = this.state.serial_numbers;
                                                                        serial_numbers[i] = e.target.value;
                                                                        this.setState({ serial_numbers: serial_numbers });
                                                                    }}
                                                                    value={this.state.serial_numbers[i]}
                                                                />
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                                <tr>
                                                    <td className="text-center"></td>
                                                    <td>
                                                        <label className="mb-2">รวมเป็นเงิน</label>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="p-3 pb-0">
                                        <div className="row">
                                            <div className="col-12 col-md-7 mb-2">
                                                <label className="mb-2">หมายเหตุ :</label>
                                                <textarea
                                                    className="form-control"
                                                    type="text"
                                                    placeholder=""
                                                    onChange={(e) => { this.setState({ remark: e.target.value }) }}
                                                    value={this.state.remark}
                                                    rows={5}
                                                />
                                            </div>
                                            <div className="col-12 col-md-5 mb-2">
                                                <div className="d-flex align-items-center justify-content-between mb-2">
                                                    <label>รวมเป็นเงิน</label>
                                                    <label>{toFixed(total(this.state.stock_item_list, "total_price_by_item"))}</label>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-2">
                                                    <label className="me-2">ส่วนลด</label>
                                                    <input
                                                        className="form-control text-end wpx-180"
                                                        type="text"
                                                        placeholder=""
                                                        onChange={(e) => {
                                                            if (!float(e.target.value)) {
                                                                return
                                                            }
                                                            this.setState({ discount: e.target.value })
                                                        }}
                                                        value={this.state.discount}
                                                    />
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-2">
                                                    <label>ราคาหลังหักส่วนลด</label>
                                                    <label>{toFixed(total(this.state.stock_item_list, "total_price_by_item") - Number(this.state.discount))}</label>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-2">
                                                    <div className="d-flex align-items-center">
                                                        <Switch onChange={(e) => {
                                                            this.setState({
                                                                is_vat: e,
                                                            })
                                                        }} checked={this.state.is_vat} />
                                                        <label className="ms-2">ภาษีมูลค่าเพิ่ม 7%</label>
                                                    </div>
                                                    <label>{this.state.is_vat ? toFixed((total(this.state.stock_item_list, "total_price_by_item") - Number(this.state.discount)) * 0.07).replaceAll(",", "") : "0.00"}</label>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-2">
                                                    <label>จำนวนเงินรวมทั้งสิ้น</label>
                                                    <label>{toFixed(total(this.state.stock_item_list, "total_price_by_item") - Number(this.state.discount) + Number(this.state.is_vat ? toFixed((total(this.state.stock_item_list, "total_price_by_item") - Number(this.state.discount)) * 0.07).replaceAll(",", "") : 0))}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-100 p-3 d-flex align-items-center justify-content-end">
                                        {this.props.location.query.id && (
                                            <select
                                                className="form-control wpx-180 mx-1"
                                                type="text"
                                                placeholder=""
                                                onChange={(e) => { 
                                                    this.setState({ decision_status: e.target.value, confirm_approve: true }) 
                                                }}
                                                value={this.state.decision_status}
                                                disabled={this.state.decision_status == 1}
                                            >
                                                <option value="0">รออนุมัติ</option>
                                                <option value="1">อนุมัติ</option>
                                                <option value="2">ไม่อนุมัติ</option>
                                            </select>
                                        )}
                                        {this.state.decision_status != 1 && (
                                            <button className="btn btn-outline-orange mx-1 px-5" onClick={() => { this.setState({ modal_sub_pay: true }) }}>
                                                ยกเลิก
                                            </button>
                                        )}
                                        {this.state.decision_status != 1 && (
                                            <button className="btn btn-orange mx-1 px-5" onClick={() => {
                                                if (!this.state.company_id) {
                                                    alert("warning", "แจ้งเตือน", "กรุณาเลือกบริษัท");
                                                    return;
                                                } else if (!this.state.warehouse_id) {
                                                    alert("warning", "แจ้งเตือน", "กรุณาเลือกคลังสินค้า");
                                                    return;
                                                } else if (this.state.stock_item_list.length === 0) {
                                                    alert("warning", "แจ้งเตือน", "กรุณาเลือกสินค้า");
                                                    return;
                                                }
                                                for (const item of this.state.stock_item_list) {
                                                    console.log(item)
                                                    if ( 
                                                        item.product_code['have_serial'] && 
                                                        ( 
                                                            item.serial_numbers.length < Number(item.quantity) || 
                                                            item.serial_numbers.length === 0 
                                                        )
                                                    ) {
                                                        alert("warning", "แจ้งเตือน", "กรุณากรอก Serial Number");
                                                        return;
                                                    } else {
                                                        for (const sn of item.serial_numbers) {
                                                            if ( !sn ){
                                                                alert("warning", "แจ้งเตือน", "กรุณากรอก Serial Number");
                                                                return;
                                                            }
                                                        }
                                                    }
                                                }
                                                if (this.props.location.query.id) {
                                                    this.Update()
                                                } else {
                                                    this.Create()
                                                }
                                            }}>
                                                บันทึก
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Approve Confirm */}
                <Modal show={this.state.confirm_approve}
                    onHide={() => { this.setState({ confirm_approve: false, decision_status: '0'}) }}>
                    <Modal.Header><Modal.Title><b>ยืนยันการ อนุมัติ ใบรับสินค้า</b></Modal.Title></Modal.Header>
                    <Modal.Footer>
                        <div className="w-100 d-flex">
                            <div className="w-50 pe-1">
                                <button className="btn btn-outline-orange w-100" onClick={() => { this.setState({ confirm_approve: false, decision_status: '0' }) }}>
                                    ยกเลิก
                                </button>
                            </div>
                            <div className="w-50 ps-1">
                                <button className="btn btn-orange w-100"
                                    onClick={() => {
                                        this.Update();
                                    }}>
                                    ยืนยัน
                                </button>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div >
        )
    }
}
